import { useId, useRef, useState, type ReactNode } from 'react';

/** Click/tap, hover or keyboard focus reveals optional context. Escape dismisses it. */
export function Hint({ label, children }: { label: string; children: ReactNode }) {
  const id = useId();
  const button = useRef<HTMLButtonElement>(null);
  const [position, setPosition] = useState<{ left: number; top: number } | null>(null);
  const show = () => {
    const rect = button.current?.getBoundingClientRect();
    if (rect)
      setPosition({
        left: Math.max(16, Math.min(rect.left, window.innerWidth - 316)),
        top: Math.min(rect.bottom + 8, window.innerHeight - 180),
      });
  };
  return (
    <span
      className="hint"
      onMouseEnter={show}
      onMouseLeave={() => {
        if (document.activeElement !== button.current) setPosition(null);
      }}
    >
      <button
        ref={button}
        type="button"
        className="hint-trigger"
        aria-label={label}
        aria-describedby={position ? id : undefined}
        onFocus={show}
        onBlur={() => setPosition(null)}
        onClick={show}
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            setPosition(null);
            e.stopPropagation();
          }
        }}
      >
        ?
      </button>
      <span
        id={id}
        role="tooltip"
        className="hint-content"
        hidden={!position}
        style={position ?? undefined}
      >
        {children}
      </span>
    </span>
  );
}
